( function ( $ ) {

	MP.dashboard_layout = function(){

		var dashboard = document.querySelector('.wrapper-dashboard');

		dashboard && lib.on(['resize'], function(){
			dashboard.style.height = lib.viewport().height - lib.offset('#wpadminbar') + 'px';
		});
	};

	MP.dashboard_help = function(){

		var btns = document.querySelectorAll('[data-help]');

		if ( ! btns ) return;

		var holder = document.createElement('div');
		holder.style.visibility = 'hidden';
		document.body.appendChild( holder );
		holder.style.top = '0px';

		var allow_help_close = true;

		[].forEach.call( btns, function ( btn ){

			btn.addEventListener( 'click', function(e){
				
				e.preventDefault();
				
				var it = this;

				var id = it.getAttribute( 'data-help' ),
					help_content = document.getElementById( id );
				
				if ( !help_content ){
					console.log('Content for ' + id + ' does not exist.');
					return;
				}
				
				holder.className = 'das-help';
				holder.style.zIndex = '9999';
				holder.style.visibility = 'visible';
				holder.innerHTML = help_content.innerHTML;
				lib.on( ['resize'], function(){
					holder.style.top = it.getBoundingClientRect().bottom + 'px';
					holder.style.left = it.getBoundingClientRect().left - ( holder.offsetWidth / 2 ) + ( it.offsetWidth / 2 ) + 'px';
				});
			});

			btn.addEventListener('mousedown', function(){
				allow_help_close = false;
			});

			btn.addEventListener('mouseup', function(){
				setTimeout(function(){
					allow_help_close = true;
				},100);
			});

		});

		holder.addEventListener( 'click', function(){
			allow_help_close = false;
		});
		holder.addEventListener( 'mouseleave', function(){
			allow_help_close = true;
		});
		document.addEventListener( 'click', function(){
			if ( allow_help_close ){
				holder.style.visibility = 'hidden';
			}
		});
		lib.on( ['scroll'], function(){
			holder.style.visibility = 'hidden';
		});

	};

	/* =================== LOGIN / REGISTER =================== */
	MP.close_login_register_popup = function(){
		$('.internal-popup-close').on('click', function(){
			window.popup._close_popup();
		});
	};

	/* =================== PLUGINS =================== */

	MP.plugins_counter = function(){
		$('#plugins_counter').text( $('.dashboard-plugin').length );
	};

	MP.plugin_toggle_view = function(){

		var sections = document.querySelectorAll( '.dashboard-plugin' );

		sections.length && [].forEach.call( sections , function ( section ){

			var btn				= section.querySelector( '.dashboard-toggle' ),
				$header			= $( section.querySelector( '.dashboard-plugin-top') ),
				$el				= $( section.querySelector( '.toggle-view' ) ),
				flag 			= true,
				aria_hidden 	= btn.getAttribute( 'aria-label' ),
				aria_shown 		= btn.getAttribute('data-ariahidden' );

			btn.addEventListener( 'click', function(){

				flag = !flag;

				var effect = flag ? 'Up' : 'Down',
					btn_class = flag ? 'remove' : 'add';

				$el.attr('aria-hidden' , flag );

				$el['slide' + effect](200);

				this.setAttribute( 'aria-label' , flag ? aria_hidden : aria_shown );

				this.classList[btn_class]( 'is-active' );

				$el.find('input')[0].focus();

			});

			$header.on('click',function(){
				btn.click();
			});

		});
	};

	MP.plugin_cancel = function(){

		var $plugin,	
			_self = this;

		$( '.cancel-plugin' ).on( 'click' , function(){

			$plugin = $(this).parents( '.dashboard-plugin' );

			$('.remove_plugin-url').text( $plugin.find('.dashboard-plugin-title').text() );
			$('.remove_plugin-id').val( $plugin.find('[name="plugin_id"]').val() );

		});

		$( '.btn-keep-plugin' ).on( 'click', function(){
			
			window.popup._close_popup();

		});

		$( '.btn-remove-plugin' ).on( 'click', function(){
			
			window.popup._close_popup();

			$plugin.slideUp( 200 , function(){
				
				$(this).remove();

				_self.plugins_counter();

				//todo: ajax to remove plugin

			});

		});
	};

	MP.plugin_code_maker = function(){
		
		var plugins = document.querySelectorAll( '.dashboard-form' );

		if ( ! plugins.length ) return;

		var Plugin_methods = function( plugin ){
			this.plugin = plugin;
			this.xmp;
			this.params = {};
			this.original_params = '/?';
			if ( this.plugin ){
				this.xmp = this.plugin.querySelector( '.copy-code' );
			}
		};

		var PMP = Plugin_methods.prototype;

		PMP.xmp_string = function(){
			
			if ( ! this.xmp ) return;
			
			// remove white space from string
			var str = 	this.xmp.textContent.replace(/(\r\n\t|\r\t|\t)/gm,"").trim();

			// insert params to string
			str = str.replace( this.original_params , '/?' + $.param( this.params) );

			this.xmp.textContent = str;

			if ( this.params ){
				this.original_params = '/?' + $.param( this.params );
			}

		};

		PMP.copy_code = function(){
			
			if ( ! this.xmp ) return;

			this.xmp_string();

			var _self = this;
			
			this.xmp.addEventListener( 'click', function(){

				// select and copy to clipboard
				
				this.select();
				document.execCommand("copy");

				// create and remove success message

				var successs_message = document.createElement('div');
				successs_message.className = 'plugin-copied';
				successs_message.innerHTML = '<span>הקוד הועתק, ניתן להדביקו באתר.</span>';
				
				if( ! _self.plugin.querySelector( '.plugin-copied') ) this.parentNode.appendChild( successs_message );

				setTimeout(function(){
					
					$( successs_message ).fadeOut(400, function(){
						successs_message.parentNode && successs_message.parentNode.removeChild( successs_message );
					});

				},3000);

			});

		};

		PMP.show_code = function(){

			var btn = this.plugin.querySelector( '.show-copy-code' ),
				code_block = this.plugin.querySelector( '.copy-code-block' );
			
			if ( ! btn || ! code_block ) return;
			
			var bool = true;

			btn.addEventListener('click', function(){

				var effect = lib.compute_style( code_block, 'display' ) === 'none' ? 'Down' : 'Up';
				
				code_block.setAttribute('aria-hidden', bool = !bool );

				$( code_block )['slide'+effect](200);

			});


		};

		[].forEach.call ( plugins, function( plugin ){
			
			var methods = new Plugin_methods( plugin );
			
			methods.copy_code();
			methods.show_code();

		});

	};

	MP.plugin_help = function(){

		var messageWindow = document.createElement('div');
		messageWindow.className = 't-help-message';

		var allow_kill = true;
		function kill(){
			$('.t-help-message').remove();
			$('.btn-dashboard-help').removeClass('is-active');
		}

		$('.btn-dashboard-help').on('click', function(e){
			
			$(this).toggleClass('is-active');

			if ( $(this).hasClass('is-active') ){
				document.body.appendChild(messageWindow);
				messageWindow.innerHTML = `
					<div class="fs-small">
						${this.getAttribute('aria-label')}
					</div>
					<div class="svg-tip svg-tip-right"></div>
					<div class="svg-tip svg-tip-left"></div>
				`;
				lib.setComponentPosition(messageWindow,this);
				allow_kill = false;
			} else {
				kill();
			}
			
		});
		$('body').delegate('.t-help-message', 'mousedown', function(){
			allow_kill = false;
		});
		$(document).on('click', ()=>{
			allow_kill && kill();
			allow_kill = true;
		});

		$(window).on('scroll resize', function(){
			kill();
		});

	};

})(window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/l-dashboard.js